// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__ktxYY","pagination__buttons":"pagination_pagination__buttons__KojOB","pagination__count":"pagination_pagination__count__3qXf-"};